import { css, Global, SerializedStyles } from '@emotion/react';
import { normalize } from 'polished';

import { theme, Theme } from './theme';

const fonts = {
  default: 'Lato, -apple-system, Helvetica Neue, Helvetica, Arial, sans-serif',
};

const styles = (theme: Theme): SerializedStyles => css`
  ${normalize()}

  *, *::before, *::after {
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    height: 100%;
  }

  body {
    background-color: ${theme.colors.background.default};
    color: ${theme.colors.text.default};
    font-family: ${fonts.default};
    font-size: ${theme.fontSizes.m};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: ${theme.lineHeights.m};
    height: 100%;
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  figure,
  figcaption,
  blockquote,
  dl,
  dd,
  dialog {
    margin: 0;
  }

  img {
    border: 0;
    vertical-align: middle;
  }

  svg {
    vertical-align: middle;
  }

  input,
  button,
  select,
  textarea {
    font: inherit;
    outline: 0;
  }

  button,
  html [type='button'],
  [type='submit'] {
    appearance: none;
  }
  input {
    -webkit-appearance: none;
  }
  input[type='date']::-webkit-clear-button,
  input[type='month']::-webkit-clear-button,
  input[type='datetime-local']::-webkit-clear-button,
  input[type='time']::-webkit-clear-button,
  input[type='week']::-webkit-clear-button {
    -webkit-appearance: radio;
  }

  #__next {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
`;

export const GlobalStyle = () => {
  return <Global styles={styles(theme)} />;
};
